<div class="tw-flex tw-flex-col tw-h-full tw-text-dark-light-dynamic">
  <div class="tw-h-full" [class.mat-card-shadow]="boxShadow">
    <div
      [ngClass]="{ 'tw-hidden': !showChartOptions, 'tw-flex-col tw-relative': layoutService.isSmallScreen$ | async }"
      class="charts-actions chart-options-mobile tw-flex tw-flex-row tw-justify-between tw-mb-2 tw-flex-wrap tw-gap-y-2 tw-text-dark-light-dynamic">
      <!-- data selection -->
      <app-option-toggle
        *ngIf="allowFieldSelection"
        label="Show:"
        [options]="seriesOptions"
        [maxOptions]="3"
        [selectedValue]="selectedSeries"
        (selectionChange)="onSeriesChanged($event)"
        class="tw-order-1 md:tw-order-2 tw-mb-2 md:tw-mb-0">
      </app-option-toggle>
    </div>
    <div class="tw-min-w-[680px] tw-relative" [style.height]="getChartContainerHeight(500)">
      <div id="highchartsContainer-{{ chartId }}" class="tw-w-full tw-h-full"></div>
    </div>
  </div>
</div>
